a.s.itemqrpicker = (function(){
	var my = {
		html5QrCode:undefined,
		pick:function(cb,o){
			var multiple = o.multiple || false;
			var filter = o.filter || {};
			tpl.run({tpl:'/tpl/shared/itemqrpicker/main.ejs?v='+v,data:{
				multiple:multiple
			},cb:function(content){
				var token = a.popup.create({
					title:'Scan QR code on items',
					slideFrom:'fromtop',
					content:content,
					submit:function(){
						// Rebound in search result
					},
					close:function(){
						my.html5QrCode.stop();
						my.html5QrCode = undefined;
					},
					ready:function(token){
						var win = $('#popupid_'+token);
						$('>.ic',win).css('height','calc(100% - 40px)');
						if (multiple) {
							// Disable submit button
							$('button[data-btn="btn_submit"]',win).prop('disabled',true);
						}
						my.html5QrCode = new Html5Qrcode("reader");
						var qrCodeSuccessCallback = function(code) {
							my.blinkBg(win);
							my.insertItem(code,win);
						}
						var qrCodeErrorCallback = function(message) {
							
						}
						var config = {
							fps: 10,
							aspectRatio: 1.0
						};
						// Start QR reader
						my.html5QrCode.start({
							facingMode: "environment"
						}, config, qrCodeSuccessCallback,qrCodeErrorCallback);
						// Bind insert button
						$('button[data-btn="btn_submit"]',win).unbind('click').click(function(){
							var iid_list = $.map($('input[name="iid[]"]',win),function(n, i){
								return Number(n.value);
							});
							cb(iid_list);
							window.history.back();
							event.preventDefault();
						});
					}
				});
			}});
		},
		blinkBg:debounce(function(win){
			$('#reader',win).parent().addClass('blink');
			setTimeout(function(){
				$('#reader',win).parent().removeClass('blink');
			},250);
		},500),
		insertItem:debounce(function(uuid,win){
			var data = {};
			data.qrid = uuid;
			data.token = localStorage.getItem('token');
			data.accountname = localStorage.getItem('accountname');
			// Show loader
			a.loader.fs.create();
			// Search for item
			$.ajax({
				type:'GET',
				url:'/api/item/load/',
				data:data,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						my.itemExist(result.item.id,win,function(exist){
							tpl.run({tpl:'/tpl/shared/itemqrpicker/listitem.ejs?v='+v,data:result.item,cb:function(listitem){
								if (!exist) {
									$('table[data-area="itemlist"] tbody',win).append(listitem);
								}
								else {
									$('table[data-area="itemlist"] tbody tr[data-iid="'+result.item.id+'"]',win).replaceWith(listitem);
								}
								my.initList(win);
							}});
						});
					}
					else {
						a.s.growl.create('Item not found','The QR code was not recognized, please try again or select the item manually',{ duration:4000 });
					}
				}
			}).done(function(){
				// Remove loader
				a.loader.fs.remove();
			});
		},500,true),
		initList:function(win){
			// Bind delete buttons
			$('button[data-action="itempickerelement_removeitem" ]',win).unbind('click').click(function(){
				$('table[data-area="itemlist"] tbody tr[data-iid="'+$(this).attr('data-iid')+'"]',win).remove();
				my.valList(win);
				event.preventDefault();
			});
			my.valList(win);
		},
		valList:function(win){
			// Enable or disable insert button
			if ($('form input[name="iid[]"]',win).length==0) {
				// Disable button
				$('button[data-btn="btn_submit"]',win).prop('disabled',true);
			}
			else {
				// Enable button
				$('button[data-btn="btn_submit"]',win).prop('disabled',false);
			}
		},
		itemExist:function(iid,area,cb){
			if ($('table tr[data-iid="'+iid+'"]',area).length>0) {
				cb(true);
			}
			else {
				cb(false);
			}
		}
	}
	return my;
}());